export const refs = {
  filtersContainer: document.querySelector('.pets-list-categories'),
  animalsContainer: document.querySelector('.pets-list-animals'),
  loadMoreBtn: document.querySelector('.pets-list-load-more-btn'),
  loader: document.querySelector('.pet-list-loader.loader'),
  paginationList: document.querySelector('.pagination-list'),
  loaderTop: document.querySelector('.pet-list-loader-top'),
};
